import React, { useState } from "react";
import "./App.css";
function App() {
  const current = new Date();

  const date = `${current.getDate()}/${
    current.getMonth() + 1
  }/${current.getFullYear()}`;

  const time = `${current.getHours()}:${
    current.getMinutes()
  }:${current.getSeconds()}`;

  const [userData, setUserData] = useState({
    date:date,
    time:time,
    item1: "",
    item2: "",
    item3: "",
    item4: "",
    item5: "",
  });

  let name,value;
  const postUserData = (event) => {
    name = event.target.name;
    value = event.target.value

    setUserData({...userData, [name]:value})
  }

  const submitData = async (event) =>{
    event.preventDefault();
    const{date,time,item1,item2,item3,item4,item5} = userData;
    const res = await fetch('https://coimbatorestockmanagement-default-rtdb.firebaseio.com/materialDataRecord.json',
    {
      method:"POST",
      headers:{
        "Content-Type":"application/json"
      },
      body:JSON.stringify({date,time,item1,item2,item3,item4,item5})
    });

    if(res){
      alert("Data Stored");
    }else{
      alert("Please fill the data");
    }

  }

  return (
    <>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg bg-body-tertiary">
        <div className="container-fluid">
          <b className="navbar-brand" href="/">
            Vendor Material Details:{date}
          </b>
          <div
            className="collapse navbar-collapse"
            id="navbarSupportedContent"
          ></div>
        </div>
      </nav>

      {/* Item names */}
      <form method="POST">
        <div display="flex" className="form-group">
          <label for="Item1">Item 1</label>
          <input
            type="number"
            name="item1"
            className="form-control"
            id="Item1"
            placeholder="Item1"
            value={userData.item1}
            onChange={postUserData}
          />
        </div>
        <br></br>
        <div display="flex" className="form-group">
          <label for="Item2">Item 2</label>
          <input
            type="number"
            name="item2"
            className="form-control"
            id="Item2"
            placeholder="Item2"
            value={userData.item2}
            onChange={postUserData}
          />
        </div>
        <br></br>
        <div display="flex" className="form-group">
          <label for="Item3">Item 3</label>
          <input
            type="number"
            name="item3"
            className="form-control"
            id="Item3"
            placeholder="Item3"
            value={userData.item3}
            onChange={postUserData}
          />
        </div>
        <br></br>
        <div display="flex" className="form-group">
          <label for="Item4">Item 4</label>
          <input
            type="number"
            name="item4"
            className="form-control"
            id="Item4"
            placeholder="Item4"
            value={userData.item4}
            onChange={postUserData}
          />
        </div>
        <br></br>
        <div display="flex" className="form-group">
          <label for="Item5">Item 5</label>
          <input
            type="number"
            name="item5"
            className="form-control"
            id="Item5"
            placeholder="Item5"
            value={userData.item5}
            onChange={postUserData}
          />
        </div>
        <br></br>
        <br></br>
        <button type="submit" className="btn btn-primary" onClick={submitData}>
          Submit
        </button>
      </form>
    </>
  );
}

export default App;
